export const alphabetOnly = /[^a-zA-Z\s]/g
export const numbersOnly = /[^0-9]/g
export const alphaNumericOnly = /[^a-zA-Z0-9\s]/g
export const alphabetDashAndPeriodOnly = /[^a-zA-Z\s\.-]/g
